<template>
	<div>
		<deposit-data
			:order="order"
		></deposit-data>
	</div>
</template>
<script>
import depositData from '@/components/profile/orders/deposit-data';
import { mapGetters } from 'vuex';

function created() {
	({ id: this.id } = this.$route.params);
	this.loadData();
}

async function loadData() {
	const headers = {
		Authorization: `Bearer ${this.token}`,
	};
	const url = `orders/${this.id}`;
	({ data: this.order } = await this.$httpJapi(url, { headers }));
	this.rowsProduct = [...this.order.details];
}

function data() {
	return {
		id: 0,
		order: {},
		rowsProduct: [],
	};
}

export default {
	computed: {
		...mapGetters([
			'token',
		]),
	},
	created,
	data,
	name: 'deposit',
	methods: {
		loadData,
	},
	components: {
		depositData,
	},
};
</script>



// WEBPACK FOOTER //
// deposit.vue?338bad1f